import { action, makeObservable, observable } from 'mobx';
import { getRandomNumber } from 'src/shared/utils/get-random-number';

import { TGeologicalLoadData } from '../../geological-load-tab/types';

import { GeoLoadStage } from './geo-load-stage.entity';
import { GeologicalLoad } from './geological-load.entity';

export class GeoLoadRigOperation {
  readonly entityId: number;
  readonly rigOperationEntityId: number;
  readonly geologicalLoad: GeologicalLoad;

  @observable stages: GeoLoadStage[] = [];

  constructor(rigOperationEntityId: number, initialGeoLoad?: TGeologicalLoadData | null) {
    this.entityId = getRandomNumber(10);

    this.rigOperationEntityId = rigOperationEntityId;
    this.geologicalLoad = new GeologicalLoad(initialGeoLoad);

    makeObservable(this);
  }

  @action.bound
  setStages(stages: GeoLoadStage[]): void {
    this.stages = stages;
  }
}
